// TODO: Remove from `core-js@4`
var $ = require('../internals/export');

var ReflectMetadataModule = require('../internals/reflect-metadata');

var anObject = require('../internals/an-object');

var ordinaryHasOwnMetadata = ReflectMetadataModule.has;
var toMetadataKey = ReflectMetadataModule.toKey; // `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata

$({
  target: 'Reflect',
  stat: true
}, {
  hasOwnMetadata: function hasOwnMetadata(metadataKey, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 3 ? undefined : toMetadataKey(arguments[2]);
    return ordinaryHasOwnMetadata(metadataKey, anObject(target), targetKey);
  }
});